import { useState } from "react";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import AuthService from "../../Api/Auth/Auth";
import Logo from "../../Components/Common/Logo";
import { Link } from "react-router-dom";
import InputFull from "../../Components/Common/InuptFull";
import LoginImageTemplate from "../../Components/Utils/LoginImageTemplate";
import { validateInput } from "../../Components/Utils/ValidationUtils";
import { connect } from "react-redux";
import { UserInfoAction } from "../../redux/action";
import { FaEye } from "react-icons/fa";
import ThemeContext, { ThemeValueProps } from "../../Context/ThemeContext";
import Routes from "../../Routes/Routes";
import PopupMessage from "../../Components/Common/PopupMessage";

const Signin = (props: any) => {
  const marginTop = `mt-8`;
  const centerItem = `flex items-center justify-center`;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const token: string | null = localStorage.getItem("token");
  const loginType: string | null = localStorage.getItem("registerType");
  const history = useHistory();
  if (token && loginType) {
    history.push("/dashboard");
  }
  const show_Password = () => {
    setShowPassword(!showPassword);
  };
  const loginHandler = async (fetchTheme?: VoidFunction) => {
    const response = await new AuthService().login({ email, password });

    if (response?.data !== undefined) {
      const { token, type } = response.data;
      localStorage.setItem("token", token);
      localStorage.setItem("registerType", type);
      if (fetchTheme !== undefined) await fetchTheme();
      if (type) {
        console.log("type", type);
      //  alert(type)
        if (type === "Moderator") {
          console.log("executing moderator");

          history.replace(Routes.moderateCourses);
        } else {
          console.log(" not executing moderator");
          history.replace("/dashboard");
        }
      }
    } else {
      console.log("Executing Error block");
      setPopupMessage(response?.errorMsg?.error || "Login failed");
setShowPopup(true);

    }
  };
 return (
  <>
    {showPopup && (
      <PopupMessage
        message={popupMessage}
        onClose={() => setShowPopup(false)}
      />
    )}

    <div className={`grid grid-cols-1 lg:grid-cols-2 w-full h-full font-lato mt-5`}>
      <div className={``}>
        <LoginImageTemplate />
      </div>

      <div className={`${centerItem} overflow-auto`}>
        <div className={``}>
          <div className={`${centerItem}`}>
            <Logo />
          </div>

          <div className={`grid justify-items-center text-lp_blue font-bold text-4xl mt-2`}>
            Welcome Back!
          </div>

          <div className={`mt-5`}>
            <InputFull
              type="email"
              label="Email"
              onChange={(event) => {
                setEmail(event.target.value);
              }}
              errCls={emailErr ? "border-red-400" : "border-gray-400"}
              onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                const isErr = validateInput("email", e.target.value);
                setEmailErr(isErr);
              }}
            />
            <div className={`p-1 text-xs text-red-600`}>{emailErr}</div>
          </div>

          <div className={`mt-4 grid`}>
            <div className="z-0">
              <InputFull
                type={showPassword ? "text" : "password"}
                label="Password"
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
                errCls={passwordErr ? "border-red-400" : "border-gray-400"}
                onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const isErr = validateInput("password", e.target.value);
                  setPasswordErr(isErr);
                }}
              />
            </div>

            <div className="float-right z-40">
              <FaEye
                className="float-right -mt-7 mr-3"
                onClick={show_Password}
              />
            </div>

            <div className={`p-1 text-xs text-red-600`}>{passwordErr}</div>
          </div>

          <ThemeContext.Consumer>
            {(context: ThemeValueProps) => {
              return (
                <div className={`mt-6`}>
                  <button
                    className={`w-full text-white bg-lp_blue text-xl p-2 rounded`}
                    onClick={() => {
                      loginHandler(context.getTheme);
                    }}
                  >
                    SIGN IN
                  </button>
                </div>
              );
            }}
          </ThemeContext.Consumer>

          <div className={`mt-3 text-lp_blue text-base`}>
            <Link to="/reset-password">
              Forgot Password? Click here to reset
            </Link>
          </div>

          <div className={`${marginTop} text-lp_blue text-xl mb-5 font-extrabold text-center`}>
            <Link to="/signup">New User? Create Account</Link>
          </div>
        </div>
      </div>
    </div>
  </>
);

};
const mapDispatchToProps = (dispatch: any) => {
  return {
    setUserInfo: (data: any) => {
      dispatch(UserInfoAction(data));
    },
  };
};
export default connect(null, mapDispatchToProps)(Signin);       

